import { FC } from "react";

import { formatPhoneNumber } from "src/helpers";
import { PrescriberInformationProps } from "./types";



const PrescriberInformation: FC<PrescriberInformationProps> = ({ title, prescriber_information, drugName }): JSX.Element => {
  return (
    <div className="card">
      <div className={`card-header ${ drugName === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">{title}</h4>
      </div>

      <div className="card-body">
        <div className="row">
            <div className="col-12 col-lg-6">
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">First name:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.first_name : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">Last Name:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.last_name : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">Street:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.street : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">City:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.city : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">State:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.state : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">Zip:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.zip : "N/A"}
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">Speciality:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.spaciality : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">NPI:</p>
                    </div>
                    <div className="col-6">
                        <p>{prescriber_information ? prescriber_information.npi : "N/A"}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">DEA:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information ? prescriber_information.dea : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">Phone Number:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information && prescriber_information.phone_number ? formatPhoneNumber(prescriber_information.phone_number) : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <p className="form-label">Fax Number:</p>
                    </div>
                    <div className="col-6">
                        <p>
                            {prescriber_information && prescriber_information.fax_number ? formatPhoneNumber(prescriber_information.fax_number) : "N/A"}
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default PrescriberInformation;
